import { formatFileSize } from "shared/utils";
import { getCookie } from "shared/utils/cookies";
import { Transforms } from "slate";

export async function uploadVideoFile(editor, file, onUpdateAttachment, lookupId, workspaceId, commentId, setLoading, folderId) {
  if (!editor || !editor.selection) return;

  const formData = new FormData();
  formData.append("files", file);

  let uploadUrl = "";
  if (commentId) {
    formData.append("module", workspaceId ? "comments" : "files");
    formData.append("lookupId", commentId);
    formData.append("folderId", lookupId);
    if(workspaceId){
      formData.append("service", workspaceId);
    }
    uploadUrl = `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`;
  } else if (workspaceId && !commentId) {
    formData.append("module", "taskplanner");
    formData.append("lookupId", lookupId);
    formData.append("service", workspaceId);
    uploadUrl = `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`;
  } else {
    uploadUrl = `${process.env.REACT_APP_PROXY_HOST}/api/v1/file/upload/content/files`;
  }

  if(folderId){
    formData.append("folderId", folderId);
  }

  setLoading(true);

  try {
    const res = await fetch(uploadUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getCookie("accessToken")}`
      },
      body: formData
    });

    const data = await res.json();
    const uploaded = Array.isArray(data) ? data[0] : data;
    const url = uploaded?.url || uploaded;
    const fileId = uploaded?.fileId || file.uid;

    if (!url) throw new Error("No video URL found in upload response");

    const videoNode = {
      type: "video",
      url,
      fileId,
      align: "left",
      width: 500,
      height: 281,
      children: [{ text: "" }]
    };

    setLoading(false);
    Transforms.insertNodes(editor, {
      type: "paragraph",
      children: [{ text: "" }]
    });
    Transforms.insertNodes(editor, videoNode);
    Transforms.insertNodes(editor, {
      type: "paragraph",
      children: [{ text: "" }]
    });

    const fileObj = {
      name: file.name,
      type: file.type,
      size: commentId ? file.size : formatFileSize(file.size),
      fileId,
      url: url,
      uid: fileId,
      lastModifiedDate: file.lastModifiedDate
    };

    onUpdateAttachment?.([fileObj], "rc");

  } catch (error) {
    console.error("Video upload failed:", error);
  }
}
